// ---------------------------------------------- modules import
import M from "materialize-css";
import React, { FunctionComponent, useEffect } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import Spinner from "react-spinkit";

import Summary from "./summary";
import SearchForm from "./searchForm";

import { IListProps } from "./common";
import { useAuth, usePosts } from "./hooks";
import { ThemeContext } from "../../../contexts/themeContext";
import PermissionHelper from "../../../store/helpers/permissionHelper";

// ---------------------------------------------- the component
const List: FunctionComponent<IListProps> = ({ menuIndex }) => {
  // ---------------------------------------------- router state
  let match = useRouteMatch();

  // ---------------------------------------------- local state
  const { profile } = useAuth();
  const {
    loading,
    error,
    fetching,
    filtered,
    criteria,
    categories,
    onFilter
  } = usePosts(menuIndex, profile);

  // ---------------------------------------------- effects
  useEffect(() => {
    const fixedFloatingActionButtons = document.querySelectorAll(
      ".fixed-action-btn"
    );

    M.FloatingActionButton.init(fixedFloatingActionButtons, {
      hoverEnabled: false
    });
  }, []);

  // ---------------------------------------------- content
  return (
    <ThemeContext.Consumer>
      {({ theme }) => (
        <div className="container">
          <div style={{ paddingLeft: "15px", marginBottom: "10px" }}>
            <span style={{ display: "block", fontSize: "0.75rem" }}>
              {PermissionHelper.getName(menuIndex).toLowerCase()}
            </span>

            <span
              style={{
                display: "inline-block",
                fontSize: "1.75rem",
                fontWeight: 300
              }}
            >
              POST LIST
            </span>
          </div>

          <SearchForm
            categories={categories}
            criteria={criteria}
            onFilter={onFilter}
          />

          {profile &&
          match &&
          PermissionHelper.getModify(profile.permissions, menuIndex) ? (
            <div
              className="fixed-action-btn direction-top"
              style={{ bottom: "45px", right: "36px" }}
            >
              <button
                className="btn-floating btn-large waves-effect waves-light"
                style={{ backgroundColor: theme.ui }}
              >
                <i className="material-icons">more_vert</i>
              </button>

              <ul>
                <li>
                  <Link
                    to={`${match.url}/add`}
                    className="btn-floating waves-effect waves-light"
                    style={{ backgroundColor: theme.ui }}
                  >
                    <i className="material-icons">add</i>
                  </Link>
                </li>
              </ul>
            </div>
          ) : null}

          <div className="section row">
            {loading || fetching || error || !filtered.length
              ? null
              : filtered.map(post =>
                  match ? (
                    <Link to={`${match.url}/${post.id}`} key={post.id}>
                      <Summary post={post} />
                    </Link>
                  ) : null
                )}
          </div>

          <div
            className={`center-align${error ? " red-text" : ""}`}
            style={{ marginTop: "3rem" }}
          >
            {loading || fetching ? (
              <Spinner name="three-bounce" fadeIn="none" />
            ) : error ? (
              error
            ) : !filtered.length ? (
              <p className="center-align">No posts found.</p>
            ) : null}
          </div>
        </div>
      )}
    </ThemeContext.Consumer>
  );
};

export default List;
